import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'

import { useLocale } from '@/features/locale/useLocale'
import { BuyButton } from '@/features/products/BuyButton'

import { formatPriceText } from '../../../../../common/src'
import { useFetchProductsQuery } from '../../../api'
import { Button } from '../../../components/buttons/Button'
import { useGameImages } from '../../../components/games/images'
import { useAppSelector } from '../../../utils/useAppSelector'
import { useBreakpoints } from '../../../utils/useBreakpoints'
import { HeroContent } from './HeroContent'

import HeroImageMobile from 'assets/images/hero/brawlstars4-mobile.png'
import HeroImage from 'assets/images/hero/brawlstars4.png'

import styles from './Hero.module.scss'

const LASER_SEASONPASS_ID = 'com.supercell.laser.scid.seasonpassbundle10'

export const BrawlPassHero = () => {
  const { push } = useRouter()
  const t = useTranslations()
  const bsImages = useGameImages('brawlstars')
  const { from } = useBreakpoints()
  const mobile = from('mobile')
  const HeroSrc = mobile ? HeroImage : HeroImageMobile
  const imagePosition = mobile ? '0% 0%' : '0% 0%'
  const market = useAppSelector((state) => state.config.market)
  const locale = useLocale()
  const viewerCountry = useAppSelector((state) => state.config.viewerCountry)
  const { data: products, isLoading } = useFetchProductsQuery({ locale, viewerCountry })
  const seasonPass = products?.find((p) => p.id === LASER_SEASONPASS_ID)
  const priceText =
    (seasonPass && market && formatPriceText(seasonPass.prices[market.currencyCountry], locale, market.currency)) ?? ''
  return (
    <>
      <div className={styles.Hero}>
        <HeroContent
          image={HeroSrc}
          imagePriority={false}
          imagePosition={imagePosition}
          title={t('hero_bp10_title_v2')}
          description={t('hero_bp10_body_v2')}
          gameLogo={bsImages.gameImage('logo')}
          gameLogoClassName={styles.BrawlStarsGameLogo}
        >
          {seasonPass ? (
            <BuyButton
              additionalClasses={styles.HeroBuyButton}
              type="Secondary"
              loading={isLoading}
              isLocked={!market}
              content={priceText}
              product={seasonPass}
            />
          ) : (
            <Button
              additionalClasses={styles.HeroBuyButton}
              type="Secondary"
              loading={isLoading}
              onClick={() => push('#brawlstars')}
              content={t('lan_hero_button5')}
            />
          )}
        </HeroContent>
      </div>
    </>
  )
}
